import React, { useContext, useEffect, useRef, useState } from 'react';
import { AlertWrapper, ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import { addBeneficiaryRequest, getPennyDrop, getSendMoneyBankList, rDmtBankList, rPayRegisterBenificiary, rPayVerifyBenificiary } from '../../utils/api';
import { clickOutside, getCurrentDate, isEmpty, overLayers } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import {ifsc} from './ifsc';
import Input from '../UIbox/Input';

const initControls = {
	
	"name": "",
	"accountNo": "",
	"ifsc": "",
	"dob": "",
	"address": "",
	"pincode": "",
	"bankId": "",
	"bankName": "",


};

export default function AddBeneficiaryModal({ modalData = null, mobileNumber = '', onCloseModal = () => {}, verifySenderStatus = () => {}, setModal ,referenceKey={}}) {
	const [controls, setControls] = useState({ ...initControls });
	const [pageMsg, setPageMsg] = useState({});
	const [bankList, setBankList] = useState([]);
	const [filterBankList, setFilterBankList] = useState(null);
	const [dropDown, setDropdown] = useState(false);
	const [searchKey, setSearchKey] = useState('');
	const [loding, setLoding] = useState(false);
	const [add, setAdd] = useState(false);

	const numberReg = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;


	const { setAlert,setRefresh, refresh,geolocation} = useContext(GlobleContaxt);

	const changeHandler = (e) => {
		const { name, value } = e.target;

		if (name === 'beneName') {
			if (!nameReg.test(value) && value) {
				return false;
			}
		}
		if ((name === 'accountNumber') || (name === "beneMobileNumber")) {
			if (!numberReg.test(value) && value) {
				return false;
			}
		}

		setControls({ ...controls, [name]: value });
		if (name === 'ifsc') {
			setControls({ ...controls, [name]: value.toUpperCase() });
		}
		if (name == 'bankId') {
			setDropdown(false);
			setSearchKey(e.target?.nextElementSibling?.innerHTML);
		}
	};

	const selectBankWithMifsc = (e,item)=>{
		const { name, value } = e.target;
		console.log("item",item)
		setControls({ ...controls, bankId: item.id,bankName:item.bankName,ifsc: item.ifsc});
		setDropdown(false);
		setSearchKey(e.target?.nextElementSibling?.innerHTML);
		
	}

	const onSubmit = () => {
		if (isEmpty(controls.name)) {
			setPageMsg({ type: 'error', msg: 'Beneficiary Name is required.' });
			return;
		} else  if(isEmpty(controls.dob)){
			setPageMsg({ type: 'error', msg: 'Beneficiary dob is required.' });
		}  else  if(isEmpty(controls.address)){
			setPageMsg({ type: 'error', msg: 'Beneficiary address is required.' });
		}  else if (controls.pincode.length < 6){
			setPageMsg({ type: 'error', msg: 'Please enter 6 digits pincode' });
		}else if (isEmpty(controls.accountNo)) {
			setPageMsg({ type: 'error', msg: 'Account number are required.' });
			return;
		} else if (isEmpty(controls.ifsc)) {
			setPageMsg({ type: 'error', msg: 'Ifsc code are required.' });
			return;
		} else if (isEmpty(controls.bankId)) {
			setPageMsg({ type: 'error', msg: 'Bank name are required.' });
			return;
		}

	
	//	addBeneficiaries();
		verifyBankAccount_()
		
	};


	const verifyBankAccount_  = () =>{

		const params = {
                accountNo: controls.accountNo,
                ifsc: controls.ifsc,
                bankId: controls.bankId,
                bankName: controls.bankName,
                senderMobile:mobileNumber,
				lattitude: geolocation?.latitude.toFixed(4),
				longitude: geolocation?.longitude.toFixed(4),
				refferenceID:referenceKey
		};
		setLoding(true);
		rPayVerifyBenificiary(params).then((resp) =>{
			if (resp?.success) {
				addBeneficiaries();
			} else {
				setLoding(false);
				setAlert({ type: 'error', msg: resp?.msg });
				
			}
		})
	}

	const addBeneficiaries = () => {
		const date = getCurrentDate('dd/mm/yyyy',controls.dob)
		const params = {
			name: controls.name,
                accountNo: controls.accountNo,
                ifsc: controls.ifsc,
                dob: date,
                address: controls.address,
                pincode: controls.pincode,
                bankId: controls.bankId,
                bankName: controls.bankName,
                senderMobile:mobileNumber,
				lattitude: geolocation?.latitude.toFixed(4),
				longitude: geolocation?.longitude.toFixed(4),
		};

		
		setSearchKey('');
		

		rPayRegisterBenificiary(params).then((response) =>{
			setControls({ ...initControls });
			setLoding(false);
			if (response?.success){
				setPageMsg({ type: 'success', text: response?.msg });
				setAlert({ type: 'success', msg: response?.msg });
						verifySenderStatus(mobileNumber);
						 setRefresh(!refresh)
						 onCloseModal();
			}else{
			   
	
				if (response?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0]});
					setPageMsg({ type: 'error', msg: response?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: response?.msg});
					setPageMsg({ type: 'error', msg: response?.msg });
				}
			}
		});

		
	};

	useEffect(() => {
		rDmtBankList().then((res) => {
			if (res?.data) {
				
			  const list = JSON.parse(res?.data)
			 
				setBankList(list?.data?.banks|| []);
				if(!isEmpty(list?.data?.banks)){
					setFilterBankList(list?.data?.banks?.slice(0, 4));
				}
			}
		});
	}, []);

	const handleFilter = (event) => {
		if (bankList) {
			const keyword = event.target.value;

			if (!nameReg.test(keyword) && keyword) {
				return false;
			}

			setSearchKey(keyword.toUpperCase());
			const pattern = new RegExp('^' + keyword, 'i');
			const filtered = bankList.filter((item, index) => {
				return pattern.test(item.bankName);
			});

			if (keyword) {
				setFilterBankList(filtered.slice(0, 4));
			} else {
				setFilterBankList([]);
			}
		}
	};




	
		const boxRef = useRef(null);
		useEffect(() =>{
			overLayers(true);
			clickOutside(true,boxRef,onCloseModal);
		
			return(() =>{
				overLayers(false)
				clickOutside(false,boxRef,onCloseModal);
			})
		
		},[]);
	

	return (
		<ModalWraper width="600px">
			<div className="modal pay-modal" ref={boxRef}>
				<div className="modal-header">
					<div className="modal-title">Add Beneficiary</div>
					<div className="modal-close" onClick={onCloseModal}>
						<IconClose />
					</div>
				</div>
				<div className="modal-body">
					<div className="pay-modal-form">
						{!isEmpty(pageMsg) && (
							<AlertWrapper className={pageMsg?.type}>
								<span className="close" onClick={() => setPageMsg({})}>
									×
								</span>
								{pageMsg?.msg}
							</AlertWrapper>
						)}
						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<Input type="text" name="name" label="Beneficiary Name"
									disabled={add} value={controls?.name} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
							<div className="col-6">
							
									<Input  type="date" name="dob" label="Beneficiary DOB"
									disabled={add} value={controls?.dob} onChange={(e) => changeHandler(e)} />
								
							</div>
							</div>
							<div className="row">
							<div className="col-6">
								<div className="form-field">
									<Input type="text" name="address" label="Beneficiary Address"
									disabled={add} value={controls?.address} onChange={(e) => changeHandler(e)} />
								</div>
							</div>
							<div className="col-6">
							
									<Input type="text" name="pincode" label="Beneficiary Pincode"
									disabled={add}  value={controls?.pincode} maxLength={6} onChange={(e) => changeHandler(e)} />
								
							</div>
							</div>
							<div className="row">
							<div className="col-6">
							
									<Input type="text" name="accountNo" label="Beneficiary Account No"
									disabled={add} value={controls?.accountNo} onChange={(e) => changeHandler(e)} />
								
							</div>
							<div className="col-6" style={{ width: '50%' }}>
								<div className="form-field" style={{ position: 'relative' }}>
									<Input type="text"
									disabled={add} name="amount"  label="Search Bank..." value={searchKey} onChange={handleFilter} onFocus={(e) => setDropdown(true) } />
									{dropDown && (
										<div className="radio-group bankList">
											{filterBankList &&
												filterBankList.map((val, index) => {
													return (
														<label style={{ display: 'block' }} key={index} className={controls.bankId == val?.id ? 'radio active' : 'radio'}>
															<input type="radio" name="bankId" value={val?.id} onChange={(e) => selectBankWithMifsc(e,val)} />
															<span className="icon-with-name">{val?.bankName}</span>
														</label>
													);
												})}
										</div>
									)}
								</div>
							</div>
							
						</div>
						
						<div className="row">
						<div className="col-6">
								
									<Input type="text"
									disabled={add} name="ifsc" label="IFSC Code" value={controls?.ifsc} onChange={(e) => changeHandler(e)} />
							
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer center">
					{<button className="button-solid" onClick={onSubmit}>
							Add Beneficiary
						</button>}
				</div>
				{loding && <Loader />}
			</div>
		</ModalWraper>
	);
}
